import { Card, ListItem, Typography } from '@mui/material'
import React from 'react'
import { Grid, Avatar, List } from '@mui/material'
import { Container } from '@mui/system'
import { Link } from 'react-router-dom'


function PersonCard(props) {
    const id = props.id
    const onTapLink = (props.type == 'teacher')? `/teacherProfile`:`/studentProfile/`
    return (
        <Grid item xs={6} >
                <Link to={onTapLink} state= { id } color="inherit" style={{textDecoration:"none"}}>
            <Container sx={{ backgroundColor: (props.type == 'teacher')? '#D2E9EE': '#F1E4FF', padding: "30px", borderRadius: "25px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)"   }}>
                <div style={{display: 'flex'}}>
                    <div style={{marginTop: 'auto', marginBottom:'auto', marginRight: '18px'}}>
                        <Avatar
                            alt={props.name}
                            src="/static/images/avatar/1.jpg"
                            sx={{ bgcolor: '#8767A8' , width: 60, height: 60 }}
                        />
                    </div>
                    <div>
                        <Typography style={{ fontWeight: 'bolder', fontSize: '20px', marginBottom: '0px' ,color: 'black'}}>{props.name}</Typography>
                        <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginTop: "0px" ,color: "#535353"}}>{props.title}</Typography>
                        <Typography style={{ fontSize: '16px',color: "#535353" }}>{props.subTitle}</Typography>
                    </div>
                </div>
            </Container>
            </Link>
        </Grid>
    )
}

export default PersonCard
